import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import NavbarNew from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import ImpersonationBanner from "../components/ImpersonationBanner";
import KtpUpdateGate from "../components/KtpUpdateGate";
import {
  Card,
  Skeleton,
  useTheme,
  useMediaQuery,
  Box,
  Drawer,
} from "@mui/material";

const SIDEBAR_WIDTH = 260;
const SIDEBAR_WIDTH_COLLAPSED = 72;

const Layout = () => {
  const [loading, setLoading] = useState(true);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box sx={{ minHeight: "100vh" }}>
      <ImpersonationBanner />
      <KtpUpdateGate />
      <Box sx={{ display: "flex" }}>
        {!isMobile && (
          <Box
            sx={{
              width: collapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH,
              flexShrink: 0,
              overflowX: "hidden",
              borderRight: "1px solid #eee",
              transition: (t) =>
                t.transitions.create("width", {
                  duration: t.transitions.duration.shortest,
                }),
            }}
          >
            <Sidebar
              collapsed={collapsed}
              onToggleCollapse={() => setCollapsed((prev) => !prev)}
            />
          </Box>
        )}

        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        >
          <Box width={260}>
            <Sidebar
              onItemClick={() => setDrawerOpen(false)}
              onToggleCollapse={() => setDrawerOpen(false)}
            />
          </Box>
        </Drawer>

        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          <NavbarNew
            isMobile={isMobile}
            onMenuClick={() => setDrawerOpen(true)}
          />

          {loading ? (
            <Card
              elevation={2}
              sx={{
                p: { xs: 2, md: 3 },
                m: { xs: 1, md: 2 },
                borderRadius: 2,
              }}
            >
              <Skeleton width="30%" height={40} sx={{ mb: 2 }} />
              <Skeleton width="100%" sx={{ mb: 3 }} />
              <Skeleton variant="rounded" width="100%" height={240} />
            </Card>
          ) : (
            <Card
              elevation={2}
              sx={{
                p: { xs: 2, md: 3 },
                m: { xs: 1, md: 2 },
                borderRadius: 2,
              }}
            >
              <Outlet />
            </Card>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
